module.exports = "<div class=\"weui_cell_ft\"><slot></slot></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/cells/cell-footer.vue
 ** module id = 69
 ** module chunks = 0
 **/